import * as React from "react";
import { Checkbox, Dropdown, Input } from "antd";
import { Filter } from "react-feather";
import { InfoTooltip } from "../../../../components/InfoTooltip";
import { BrowserColumnHeaderProps } from "../types";
import styles from "../NGProviderBrowser.module.scss";

const SortIcons: React.FC<{ active: "up" | "down" | "none" }> = ({ active }) => {
  const size = 5;
  return (
    <div className="flex flex-col gap-1">
      <span
        style={{
          width: 0,
          height: 0,
          borderLeft: `${size}px solid transparent`,
          borderRight: `${size}px solid transparent`,
          borderBottom: `${size}px solid ${active === "up" ? "var(--color-link)" : "var(--color-gray-400)"}`,
        }}
      />
      <span
        style={{
          width: 0,
          height: 0,
          borderLeft: `${size}px solid transparent`,
          borderRight: `${size}px solid transparent`,
          borderTop: `${size}px solid ${active === "down" ? "var(--color-link)" : "var(--color-gray-400)"}`,
        }}
      />
    </div>
  );
};

export const BrowserColumnHeader: React.FC<BrowserColumnHeaderProps> = React.memo(
  ({
    label,
    isFirst,
    isLast,
    tooltip,
    canFilter,
    filterValue,
    onFilterChange,
    hasDistinctFilter,
    distinctValues,
    filteredDistinctValues,
    onDistinctFilterToggle,
    sortable,
    sortKey,
    sortType,
    onSort,
  }) => {
    const hasFilteredValues = filteredDistinctValues.length > 0;

    return (
      <div
        className={styles.columnHeader}
        style={{
          borderRadius: 0,
          borderTopLeftRadius: isFirst ? 6 : 0,
          borderBottomLeftRadius: isFirst ? 6 : 0,
          borderTopRightRadius: isLast ? 6 : 0,
          borderBottomRightRadius: isLast ? 6 : 0,
        }}
      >
        <span className={styles.columnLabel}>{label}</span>
        {tooltip ? <InfoTooltip title={tooltip} /> : null}

        {canFilter ? (
          <Input
            size="small"
            className={styles.columnFilterInput}
            placeholder={`Filter by ${label}`}
            value={filterValue}
            allowClear
            onChange={(e) => onFilterChange(e.target.value)}
          />
        ) : (
          <div className={styles.columnSpacer} />
        )}

        {hasDistinctFilter && distinctValues.length > 0 ? (
          <Dropdown
            trigger={["click"]}
            popupRender={() => (
              <div className={styles.distinctFilterDropdown} onClick={(e) => e.stopPropagation()}>
                {distinctValues.map((value) => (
                  <div
                    className={styles.distinctFilterItem}
                    key={`${label}---${value}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDistinctFilterToggle(value);
                    }}
                  >
                    <Checkbox checked={filteredDistinctValues.includes(value)} onChange={() => {}}>
                      {value}
                    </Checkbox>
                  </div>
                ))}
              </div>
            )}
          >
            <button type="button" className={styles.iconButton}>
              <Filter className={`${styles.icon} ${hasFilteredValues ? styles.iconActive : ""}`} size={16} />
            </button>
          </Dropdown>
        ) : null}

        {sortable ? (
          <button type="button" className={styles.sortButton} onClick={onSort}>
            <SortIcons
              active={sortKey === label ? (sortType === "asc" ? "up" : sortType === "desc" ? "down" : "none") : "none"}
            />
          </button>
        ) : null}

        {!isLast && <div className={styles.columnDivider} />}
      </div>
    );
  },
);

BrowserColumnHeader.displayName = "BrowserColumnHeader";
